// ============================================================================
// HOSTED FLOW BETA — enjin hantar "Submit" pelanggan ke QUEUE Central Worker.
// ============================================================================
// Dipanggil oleh WorkspaceView.handleRunFlow BILA pelanggan pilih mode Hosted.
// ⛔ TIADA extension / SESAAT_DIRECT_FLOW di sini — job masuk Firestore queue (PC ofis).
// Enjin TULEN (tiada React/DOM) supaya boleh uji offline tanpa emulator — `enqueue`
// DISUNTIK (services/centralWorkerService.enqueueFlowJob sebenar; mock dalam ujian).
//
// Idempotency DI SERVER (uid_productId_setKey_tarikh) → dua klik Submit / retry selepas
// timeout = job SAMA dipulangkan (duplicate:true), BUKAN job baharu. Sahkan SERVER —
// enqueue mengesahkan uid, pemilikan card, kelayakan Lite LP, model, prompt, gambar, kuota.
//
// Model TETAP Veo 3.1 Lite Lower Priority ('lower_priority', 0 kredit Ultra — lihat
// flow-central-worker/kos-model.mjs). Workflow ikut pilihan customer ('kad' | 'generate').

export const HOSTED_MODEL = 'lower_priority';

// Error ini bermaksud backend TIDAK dapat dicapai (bukan tolakan sah spt kuota) —
// pemanggil WAJIB JANGAN berpura-pura Submit berjaya (keputusan user P1 #6).
const OFFLINE_SEBAB = new Set(['HOSTED_BETA_DISABLED', 'SILA_LOG_MASUK']);
export function sebabOffline(err) {
  if (!err) return false;
  const m = err.message || '';
  if (OFFLINE_SEBAB.has(m)) return true;
  // Timeout / rangkaian putus / CORS → tiada HTTP status (fetch reject). HTTP 5xx juga = backend bermasalah.
  if (err.status == null) return true;
  return err.status >= 500;
}

/**
 * Hantar SATU job per (productId, setKey) ke queue. Berhenti BISING bila backend offline.
 * @param enqueue  async ({productId,setKey,model,workflow}) => { jobId, duplicate? }  (throw bila gagal)
 * @param items    [{ productId, setKey }]  — hasil productsToRun × sets terpilih
 * @param workflow 'kad' | 'generate'
 * @param onProgress (siap, jumlah) => void
 * @returns { dihantar:[], duplicate:[], gagal:[], offline:boolean }
 */
export async function hantarHostedBeta({ enqueue, items, model = HOSTED_MODEL, workflow = 'generate', onProgress, batchId, openBatch, sealBatch }) {
  const hasil = { dihantar: [], duplicate: [], gagal: [], offline: false, batchId: batchId || null };
  if (!Array.isArray(items) || items.length === 0) return hasil;
  // Buka manifest batch DAHULU (hantar niat penuh untuk email ringkasan satu-batch). Non-fatal:
  // kalau gagal, submission teruskan — cuma tiada notifikasi batch (degrade selamat, bukan email salah).
  if (openBatch && batchId) {
    try { await openBatch(batchId, items.map((i) => ({ productId: i.productId, setKey: i.setKey }))); }
    catch (e) { if (sebabOffline(e)) { hasil.offline = true; return hasil; } /* selain offline: degrade tanpa batch */ }
  }
  let siap = 0;
  for (const it of items) {
    try {
      const r = await enqueue({ productId: it.productId, setKey: it.setKey, model, workflow, batchId });
      if (r && r.duplicate) hasil.duplicate.push({ ...it, jobId: r.jobId });
      else hasil.dihantar.push({ ...it, jobId: r && r.jobId });
    } catch (e) {
      hasil.gagal.push({ ...it, error: (e && e.message) || 'ENQUEUE_FAILED', status: e && e.status });
      if (sebabOffline(e)) { hasil.offline = true; break; } // backend mati → henti, jangan pura-pura jadi
    }
    siap++;
    if (onProgress) { try { onProgress(siap, items.length); } catch { /* abai */ } }
  }
  // Seal manifest = "tiada job lagi masuk" → benarkan finalize + email bila semua selesai. JANGAN seal
  // bila backend mati (batch 'open' basi akan di-seal oleh recoverStale kemudian).
  if (sealBatch && batchId && !hasil.offline) {
    try { await sealBatch(batchId); } catch { /* non-fatal: recoverStale akan seal batch basi */ }
  }
  return hasil;
}
